import { useEffect, useState } from "react";
import { Gauge } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

// "You've used 80% of your visits" + one-tap CA$29.99 top-up (adds 1,000 visits on top for this month).
export const VisitsUpsellBanner = ({ visits: given }) => {
  const [visits, setVisits] = useState(given || null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (given) { setVisits(given); return; }
    api.get("/merchant/website-visits").then((r) => setVisits(r.data)).catch(() => {});
  }, [given]);
  const pack = visits?.visit_pack;
  if (!pack || !pack.near_limit) return null;

  const topUp = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/billing/checkout", { tier: "visits_pack_1k", origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) {
      toast.error(e.response?.data?.detail?.message || e.response?.data?.detail || "Could not start the top-up");
      setBusy(false);
    }
  };

  const full = pack.remaining === 0;
  return (
    <div className={`pf-card p-5 mt-4 border ${full ? "border-rose-200 bg-rose-50/50" : "border-amber-200 bg-amber-50/50"} flex items-start gap-4 flex-wrap`} data-testid="visits-upsell-banner">
      <Gauge className={`w-6 h-6 shrink-0 mt-0.5 ${full ? "text-rose-700" : "text-amber-700"}`} />
      <div className="flex-1 min-w-[220px]">
        <div className="font-semibold text-slate-900" data-testid="visits-upsell-title">
          {full ? "You've used all your website visits this month" : `You've used ${Math.floor(pack.usage_pct)}% of your website visits`}
        </div>
        <p className="text-sm text-slate-600 mt-1" data-testid="visits-upsell-usage">
          {pack.used_this_month.toLocaleString()} of {pack.size.toLocaleString()} used · {pack.remaining.toLocaleString()} left until the 1st.
          {" "}Add 1,000 more visits on top for this month.
        </p>
      </div>
      <button onClick={topUp} disabled={busy} className="pf-btn-primary px-5 py-2.5 rounded-full text-sm font-semibold disabled:opacity-60 self-center" data-testid="visits-upsell-topup">
        {busy ? "Opening checkout…" : "Add 1,000 visits · CA$29.99"}
      </button>
    </div>
  );
};
